module.exports = __webpack_public_path__ + "img/40.d3feb00c.png";